import {
  PAYMENT_PROVIDER,
  TFestivalPaymentProvider,
} from '../../home/components/groups/GroupsTab'

export type CurrencyAlignment = 'BEFORE_PRICE' | 'AFTER_PRICE'
export type paymentProviderName = 'BT_IPAY' | 'STRIPE' | 'PULSAR'
export interface ICurrency {
  id: string
  name: string
  symbol: string
  symbolAlignment: CurrencyAlignment
}

export interface IGroupCurrencyDetails {
  id: string
  name: string
  active: boolean
  exchangeRate: number
  default: boolean
}

export interface IGroupFestival {
  festivalId: string
  paymentProviderName: paymentProviderName
  paymentProviderSecret: string
  paymentProviderUsername: string
  paymentProviderPassword: string
  currencies: Omit<IGroupCurrencyDetails, 'exchangeRate'>[]
  festivalPaymentProviderDtos: TFestivalPaymentProvider[]
}

export interface IGroupFestivalPayload {
  festivalId: string
  paymentProviderSecret?: string
  paymentProviderUsername?: string
  paymentProviderPassword?: string
  currencies: Omit<IGroupCurrencyDetails, 'exchangeRate'>[]
  festivalPaymentProviderDtos: TFestivalPaymentProvider[]
}

export interface IGroup {
  id: string
  name: string
  currencies: ICurrency[]
  currenciesDetails: IGroupCurrencyDetails[]
  festivals: IGroupFestival[]
}

export interface PaymentProviderChain {
  chainName: string
  chainId: string
  taxPercent: string
}

export interface PaymentProviderToken {
  tokenSymbol: string
  exchangeRate: string
}

export interface PaymentProvider {
  id: string
  title: string
  name: PAYMENT_PROVIDER
  secret: string
  username: string
  password: string
  verificationKey: string
  // Pulsar
  chains?: PaymentProviderChain[]
  tokens?: PaymentProviderToken[]
}

export enum ApplePaySupportedNetworks {
  VISA = 'Visa',
  MASTER_CARD = 'MasterCard',
  AMEX = 'Amex',
  DISCOVER = 'Discover',
  JCB = 'JCB',
  MAESTRO = 'Maestro',
  ELECTRON = 'Electron',
  CHINA_UNION_PAY = 'ChinaUnionPay',
  ELO = 'Elo',
  EFTPOS = 'EftposAu',
}

export enum ApplePayMerchantCapabilities {
  SUPPORTS_3DS = '3DS',
  SUPPORTS_CREDIT = 'Credit',
  SUPPORTS_DEBIT = 'Debit',
  SUPPORTS_EMV = 'EMV',
}

export type ApplePayConfig = {
  id: string
  festivalId: string
  paymentProviderId: string
  merchantIdentifier: string
  displayName: string
  countryCode: string
  stripePublishableKey?: string
  supportedNetworks: ApplePaySupportedNetworks[]
  merchantCapabilities: ApplePayMerchantCapabilities[]
  // Response-only flags: key material is never returned, only whether it exists.
  hasCertificate?: boolean
  hasPrivateKey?: boolean
}

export enum GooglePayCardNetworks {
  AMEX = 'Amex',
  DISCOVER = 'Discover',
  INTERAC = 'Interac',
  JCB = 'JCB',
  MASTERCARD = 'Mastercard',
  VISA = 'Visa',
}

export enum GooglePayAuthMethods {
  PAN_ONLY = 'PAN_ONLY',
  CRYPTOGRAM_3DS = 'CRYPTOGRAM_3DS',
}

export type GooglePayConfig = {
  id: string
  festivalId: string
  paymentProviderId: string
  environment: string
  gateway: string
  merchantName?: string
  merchantId?: string
  countryCode: string
  stripeVersion?: string
  stripePublishableKey?: string
  cardNetworks: GooglePayCardNetworks[]
  authMethods: GooglePayAuthMethods[]
}
